import { Children, isValidElement, useRef, useState } from 'react'
import { ArrowDropDown } from '@mui/icons-material'
import {
    Button,
    ButtonGroup,
    type ButtonGroupProps,
    type ButtonProps,
    MenuItem,
    type MenuItemProps,
    MenuList,
    Popover,
} from '@mui/material'

export interface SplitButtonProps extends ButtonGroupProps {
    popperWidth?: number
}

export const SplitButtons = ({
    children,
    popperWidth,
    ...props
}: SplitButtonProps) => {
    const buttonGroupRef = useRef<HTMLDivElement>(null)

    const [isMenuOpen, setMenuOpen] = useState(false)
    const onOpen = () => setMenuOpen(true)
    const onClose = () => setMenuOpen(false)

    const [currentItem, setCurrentItem] = useState<number>(0)

    const buttons = Children.toArray(children).filter(
        (child): child is React.ReactElement<ButtonProps> =>
            isValidElement(child) && child.type === Button,
    )

    if (!buttons.length) {
        return null
    }

    const menuItems = buttons.map((button, index) => {
        const onClick = () => {
            setCurrentItem(index)
            onClose()
        }
        return (
            <MenuItem
                key={index}
                {...(button.props as MenuItemProps)}
                onClick={onClick}
            />
        )
    })

    return (
        <>
            <ButtonGroup ref={buttonGroupRef} {...props}>
                <Button {...buttons[currentItem].props}></Button>
                <Button sx={{ width: 16, px: 0 }} onClick={onOpen}>
                    <ArrowDropDown />
                </Button>
            </ButtonGroup>
            <Popover
                open={isMenuOpen}
                anchorEl={buttonGroupRef.current}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transitionDuration={100}
                slotProps={{
                    paper: {
                        sx: {
                            width:
                                popperWidth ||
                                buttonGroupRef.current?.offsetWidth,
                            overflowY: 'auto',
                        },
                    },
                }}>
                <MenuList>{menuItems}</MenuList>
            </Popover>
        </>
    )
}
